import { useContext } from 'react';
import { AnalyticsContext } from '@/providers/AnalyticsProvider';

/**
 * Hook to access analytics tracking functions. Thin wrapper around mixpanel.
 * Must be used within an AnalyticsProvider. Currently only exposes the `track` method.
 * To expose further methods, update the AnalyticsContextValue interface in AnalyticsProvider.tsx.
 * @returns { track: (event: string, properties?: Record<string, any>) => void }
 */
const useAnalytics = () => {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  // https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#track-events
  return context.analytics;
};

export default useAnalytics;
